import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MergeOutlinedSvg from "@ant-design/icons-svg/es/asn/MergeOutlined";
import AntdIcon from '../components/AntdIcon';
var MergeOutlined = function MergeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: MergeOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(MergeOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MergeOutlined';
}
export default RefIcon;